import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyCertificatStatus = createAsyncThunk('/dashboard_detail_company_certificat_status/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyCertifcatStatusDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyCertificatStatusSlice = createSlice({
    name: 'dashboard_detail_company_certificat_status',
    initialState: {
        isLoading: false,
        dashboard_detail_company_certificat_status: []
    },

    /*extraReducers: {
        [getDetailCompanyCertificatStatus.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyCertificatStatus.fulfilled]: (state, action) => {
            state.dashboard_detail_company_certificat_status = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyCertificatStatus.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyCertificatStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyCertificatStatus.fulfilled, (state, action) => {
                state.dashboard_detail_company_certificat_status = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompanyCertificatStatus.rejected, (state) => {
                state.isLoading = false;
            });
    },
})

export default dashboardDetailCompanyCertificatStatusSlice.reducer